import { IconButton, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: 'relative',
  width: 40,
  height: 40,
  borderRadius: '50%',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' 
      ? 'rgba(255, 255, 255, 0.1)' 
      : 'rgba(0, 0, 0, 0.1)',
  },
}));

const IconWrapper = styled(motion.div)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
});

export default function ThemeToggle({ onChange }) {
  const theme = useTheme();
  const [mounted, setMounted] = useState(false);

  // Prevent hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <StyledIconButton
      onClick={onChange}
      aria-label="Toggle theme"
    >
      <IconWrapper
        key={theme.palette.mode}
        initial={{ rotate: -30, opacity: 0 }}
        animate={{ rotate: 0, opacity: 1 }}
        exit={{ rotate: 30, opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        {theme.palette.mode === 'dark' ? (
          <LightModeRoundedIcon
            sx={{
              color: 'primary.main',
              fontSize: 24,
            }}
          />
        ) : (
          <DarkModeRoundedIcon
            sx={{
              color: 'primary.main',
              fontSize: 24,
            }}
          />
        )}
      </IconWrapper>
    </StyledIconButton>
  );
} 